// Subscribes to the real-time notifications namespace and calls `onNew` for
// each pushed notification. Reconnects automatically; cleans up on unmount.
import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { API_URL } from '../../api/api';

export default function useNotificationSocket(onNew) {
  const cbRef = useRef(onNew);
  cbRef.current = onNew;

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token || !API_URL) return undefined;

    const socket = io(`${API_URL}/notifications`, {
      auth: { token },
      transports: ['websocket', 'polling'],
      reconnection: true,
    });

    socket.on('notification:new', (n) => {
      if (n) cbRef.current?.(n);
    });

    return () => socket.disconnect();
  }, []);
}
